// extracted by mini-css-extract-plugin
module.exports = {"staticPageView":"StaticPageView__staticPageView"};